import { ReactElement } from 'react'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { StoreInterface } from '../../store/store'

interface ProtectedRouteProps {
  children: ReactElement
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { accessToken, profile } = useSelector((store: StoreInterface) => {
    return store.profile
  })

  if (!accessToken || !profile?.id) {
    return <Navigate to="/" replace />
  }

  return children
}

export default ProtectedRoute